import { SVGProps } from 'react';

const IcAccountV2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    {...props}
  >
    <circle cx='16' cy='8.26665' r='4.38519' fill='#232F3E' />
    <path
      d='M7.22961 26.9038H24.7704L24.2831 19.9798L22.3341 17.0948L16.9745 15.9408L11.6148 16.5178L7.71686 20.5568L7.22961 26.9038Z'
      fill='#232F3E'
    />
    <path
      d='M16 14.2963C14.9158 14.2963 13.8561 13.9749 12.9546 13.3725C12.0532 12.7702 11.3506 11.9141 10.9357 10.9125C10.5209 9.91092 10.4123 8.80878 10.6238 7.74547C10.8353 6.68217 11.3574 5.70546 12.124 4.93887C12.8906 4.17227 13.8673 3.65021 14.9306 3.4387C15.9939 3.2272 17.096 3.33575 18.0976 3.75063C19.0993 4.16551 19.9553 4.86808 20.5577 5.76951C21.16 6.67093 21.4815 7.73072 21.4815 8.81486C21.4815 10.2686 20.9039 11.6629 19.876 12.6908C18.848 13.7188 17.4538 14.2963 16 14.2963ZM16 5.52597C15.3495 5.52597 14.7136 5.71886 14.1728 6.08025C13.6319 6.44163 13.2104 6.95529 12.9614 7.55625C12.7125 8.15722 12.6474 8.81851 12.7743 9.45649C12.9012 10.0945 13.2144 10.6805 13.6744 11.1405C14.1343 11.6004 14.7204 11.9136 15.3583 12.0406C15.9963 12.1675 16.6576 12.1023 17.2586 11.8534C17.8595 11.6045 18.3732 11.1829 18.7346 10.6421C19.096 10.1012 19.2889 9.46534 19.2889 8.81486C19.2889 7.94259 18.9424 7.10605 18.3256 6.48926C17.7088 5.87248 16.8722 5.52597 16 5.52597Z'
      fill='#232F3E'
    />
    <path
      d='M24.88 28H7.11997C6.85829 28 6.60732 27.8845 6.42229 27.6789C6.23725 27.4733 6.1333 27.1945 6.1333 26.9037V23.6149C6.1333 21.2888 6.96492 19.058 8.4452 17.4133C9.92549 15.7685 11.9332 14.8445 14.0266 14.8445H17.9733C20.0667 14.8445 22.0744 15.7685 23.5547 17.4133C25.035 19.058 25.8666 21.2888 25.8666 23.6149V26.9037C25.8666 27.1945 25.7627 27.4733 25.5776 27.6789C25.3926 27.8845 25.1416 28 24.88 28ZM8.10663 25.8074H23.8933V23.6149C23.8933 21.8703 23.2696 20.1972 22.1594 18.9637C21.0492 17.7301 19.5434 17.0371 17.9733 17.0371H14.0266C12.4566 17.0371 10.9508 17.7301 9.84056 18.9637C8.73035 20.1972 8.10663 21.8703 8.10663 23.6149V25.8074Z'
      fill='#232F3E'
    />
  </svg>
);
export default IcAccountV2;
